import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-op-manage-order-site',
  templateUrl: './op-manage-order-site.component.html',
  styleUrls: ['./op-manage-order-site.component.css']
})
export class OpManageOrderSiteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    
  }

}
